/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types',
	'./PreviewVisualItem',
	'../../../widgets/livewidget/nls/StringResources'
], function(
	React,
	UI_Toolkit,
	PropTypes,
	PreviewVisualItem,
	StringResources
) {

	const { Component } = React;
	const { FlexLayout, FlexItem, VSpacer, Label } = UI_Toolkit;

	class CustomPreviewWidgetsComponent extends Component {

		render () {
			const { previewItems } = this.props;
			const content = [];

			previewItems.forEach((item) => {
				content.push(this._renderPreviewItem(item));
			});

			return (
				<FlexLayout
					fullHeight
					direction='column'
					justifyContent='flex-start'
				>
					<FlexItem>
						<VSpacer size={2} />
					</FlexItem>
					<FlexItem>
						<Label className='vis-custom-preview-widget-label' label={StringResources.get('extVisCustomPreviewWidgets')}/>
					</FlexItem>
					<FlexItem>
						<VSpacer/>
					</FlexItem>
					<FlexItem height='90px'>
						<FlexLayout
							fullHeight
							direction='row'
							justifyContent='flex-start'
						>
							{content}
						</FlexLayout>
					</FlexItem>
					<FlexItem>
						<VSpacer size={2.5} />
					</FlexItem>
				</FlexLayout>
			);
		}

		_renderPreviewItem (item) {
			const { handlers, dashboardApi } = this.props;
			const iconsFeature = dashboardApi.getFeature('Icons');

			return (
				<FlexItem
					grow={1}
					shrink={1}
					className='vis-custom-preview-item'
				>
					<FlexLayout
						fullHeight
						direction='column'
						justifyContent='flex-start'
					>
						<FlexItem>
							<PreviewVisualItem
								item={item}
								handlers={handlers}
								iconsFeature={iconsFeature}
							/>
						</FlexItem>
					</FlexLayout>
				</FlexItem>
			);
		}
	}

	CustomPreviewWidgetsComponent.propTypes = {
		previewItems: PropTypes.array.isRequired,
		dashboardApi: PropTypes.object.isRequired,
		handlers: PropTypes.shape({
			componentDidMountCallback: PropTypes.func.isRequired,
			componentWillUnmountCallback: PropTypes.func.isRequired,
			isSDKActive: PropTypes.func.isRequired
		}).isRequired
	};

	return CustomPreviewWidgetsComponent;
});
